import(/* webpackMode: "eager", webpackExports: ["GoogleApiUserDataPageContent"] */ "/vercel/path0/src/components/inbound-gpt/legal-pages.tsx");
